import notifications from 'modules/notifications';
import store from '../../store';

export function showAPIError(error) {
  const exception = typeof error === 'string' ? error : '';

  store.dispatch(notifications.error(exception));
}
